import { Component, OnInit } from '@angular/core';
import { GrocyStockEntry } from '../../../../../core/entities/grocy/stock-entries/stock-entry.entity';
import { GrocyStockLog } from '../../../../../core/entities/grocy/stock-logs/stock-log.entity';
import { ProductActionType } from '../../../../../core/enums/product-actions/product-action-type.enum';
import { GrocyDashboardService } from '../../../shared/services/dashboard.service';
import { GrocyDashboardQuickActionForm } from '../../forms/dashboard-quick-action.form';
import { GrocyDashboardQuickActionForms } from '../../models/dashboard-forms.model';
import { GrocyActionDialogComponent } from '../action-dialog/action-dialog.component';

@Component({
  selector: 'app-grocy-quick-action-dialog',
  templateUrl: './quick-action-dialog.component.html',
  styleUrl: './quick-action-dialog.component.scss',
})
export class GrocyQuickActionDialogComponent extends GrocyActionDialogComponent implements OnInit {
  productActionTypes = Object.values(ProductActionType).filter(value => value !== ProductActionType.Purchase);
  showErrors = false;

  constructor(service: GrocyDashboardService) {
    super(service);
  }

  ngOnInit(): void {
    if (this.productActionType === ProductActionType.Purchase) {
      this.setProductActionType(ProductActionType.Consume);
    }
  }

  get form(): GrocyDashboardQuickActionForm<any> {
    switch (this.productActionType) {
      case ProductActionType.Consume:
        return this.quickActionForms.consume;
      case ProductActionType.Transfer:
        return this.quickActionForms.transfer;
      default:
        return this.quickActionForms.open;
    }
  }

  get isConsume(): boolean {
    return this.productActionType === ProductActionType.Consume;
  }

  get isLoading(): boolean {
    return this.service.state.isLoading;
  }

  get isSubmitting(): boolean {
    return this.service.state.isSubmitting;
  }

  get isTransfer(): boolean {
    return this.productActionType === ProductActionType.Transfer;
  }

  get quickActionForms(): GrocyDashboardQuickActionForms {
    return this.forms.quickAction;
  }

  get recentStockLogs(): GrocyStockLog[] {
    return this.service.selectedProduct()?.recentStockLogs || [];
  }

  get stockEntries(): GrocyStockEntry[] {
    return this.service.selectedProduct()?.stockEntries || [];
  }

  submit(): void {
    this.service.submitQuickAction(this.form.productAction).subscribe();
  }

  getStockEntryDisplayValue(stockEntry: GrocyStockEntry): string {
    let stockEntryDisplayValue = `${stockEntry.amount}`;

    if (stockEntry.amount === 1) {
      stockEntryDisplayValue += ` ${this.form.quantityUnit?.name}`;
    } else {
      stockEntryDisplayValue += ` ${this.form.quantityUnit?.namePlural}`;
    }

    if (stockEntry.open) {
      stockEntryDisplayValue += ' (opened) ';
    }

    stockEntryDisplayValue += ` · ${stockEntry.location.name}`;

    return stockEntryDisplayValue;
  }
}
